import React from "react";
import { APP_ROUTES } from "../constants/approutes";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../components/login";
import Dashboard from "../components/Dashboard/dashboard";
import Patientregister from "../components/PatientRegister/Patientregister";
import VitalDetails from "../components/PatientRegister/VitalDetails";
import Medicalhistory from "../components/PatientRegister/MedicalHistory";
import SlotBooking from "../components/PatientRegister/SlotBooking";
import Signup from "../components/signup";
import QueueManagement from "../components/Queuemanagement/QueueManagement";
import PatientPreview from "../components/PatientRegister/PatientPreview";
import BookService from "../components/BookService";
import DoctorOnboarding from "../components/DoctorOnboard/DoctorOnboarding";
import DoctorEdit from "../components/DoctorOnboard/DoctorEdit";
import Paymentpage from "../components/Payment/index";
import OrderStatus from "../components/Payment/orderStatus";
import Reports from "../components/Reports/index";
import Payment from "../components/Dashboard/paymentdetails";
import PatientDetails from "../components/Dashboard/PatientDetails/index";
import FullScreenLoader from "../components/FullScreenLoader";
import Viewvital from "../components/Dashboard/PatientDetails/ViewVital";
import FormComponent from "../components/PatientRegister/FormComponent";
import VideoCapture from "../components/PatientRegister/VideoCapture";
import Labcart from "../components/Cart/Labcart";
import CartDropdown from "../components/CartDropdown";
import MedicineCartPage from "../components/MedicineCartPage";
import Newcaresathi from "../components/CareSathi/Newcaresathi";
import LabCartPage from "../components/LabCartPage";
import DeliveryModal from "../components/DeliveryModal";
import Sharecall from "../components/Sharecall";
import PatientDetailsdata from "../components/PatientRegister/PatientDetailsdata";
import PatientView from "../components/PatientRegister/PatientView";
import ClinicDiagnosticDetails from "../components/Dashboard/ClinicDiagnosticDetails"
import ClinicMedicineDetails from "../components/Dashboard/ClinicMedicineDetails"
import ClinicRadiologyDetails from "../components/Dashboard/ClinicRadiologyDetails";
import ClinicSurgeryDetails from "../components/Dashboard/ClinicSurgeryDetails";
import ClinicAmbulanceDetails from "../components/Dashboard/ClinicAmbulanceDetails";
import BookServicescard from "../components/PatientRegister/BookServicescard";
import MyProfile from "../components/MyProfile/Index"
import AdminProfile from "../components/MyProfile/AdminProfile.jsx"
import ChangePassword from "../components/MyProfile/changePassword";
import FeedbackPage from "../components/MyProfile/feedback";
import ClinicStaffOnboard from "../components/Dashboard/clinicStaffOnboard";
import ClinicStaffEdit from "../components/Dashboard/clinicStaffEdit";
import DoctorList from "../components/Dashboard/DoctorList";
import OrderTracking from "../components/OrderTracking/OrderTracking";
import ReceptionistList from "../components/Dashboard/ReceptionistList";
import PatientList from "../components/Dashboard/PatientList";
import PatientPendingList from "../components/Dashboard/PatientPendingList";
import ConsultationList from "../components/Dashboard/ConsultationList";
import EditPrescriptionPage from "../components/Dashboard/EditPrescriptionPage";
import DoctorDetails from "../components/DoctorDetails/DoctorDetails";
import AddAddress from "../components/AddAddress";
import ClinicOnboarding from "../components/ClinicOnboarding/ClinicOnboarding";
import HospitalList from "../components/ClinicOnboarding/HospitalList";
import AdminOnboarding from "../components/AdminOnboarding/index.jsx";
import AdminList from "../components/AdminOnboarding/AdminList.jsx";
import PatientFeedback from "../components/Feedback/PatientFeedback";
import CurebayDoctorOnboarding from "../curebay/CurebayDoctor/CurebayDoctorOnboarding";
import CurebayDoctorVerify from "../curebay/CurebayDoctor/CurebayDoctorVerify";
import CurebayDoctorList from "../curebay/CurebayDoctor/CurebayDoctorList";
import CurebayDoctorEdit from "../curebay/CurebayDoctor/CurebayDoctorEdit";
import CurebayPatientFeedback from "../curebay/CurebayDoctor/CurebayPatientFeedback";
import CurebayPaymentInvoice from "../curebay/CurebayPaymentInvoice";
import CurebaySlotManagement from "../curebay/CurebaySlotManagement";
import CurebayBackofficeDashboard from "../components/backofficedashboard";
import CurebayLeave from "../curebay/CurebayDoctor/CurebayLeave";
import CurebayDiagnosisMaster from "../curebay/CurebayDiagnosisMaster";
import CurebayDoctorPayments from "../curebay/CurebayDoctor/CurebayDoctorPayments";
import ViewPrescription from "../curebay/CurebayDoctor/ViewPrescription";
import CampPatient from "../components/CampPatient/CampPatient";
import CampDetailsList from "../components/CampPatient/CampDetailsList";
import CampPatientDetailPage from "../components/CampPatient/CampPatientDetailPage";
import KavachEnrollment from "../components/Dashboard/KavachEnrollment";
import CurebayReferralDoctors from "../components/PatientRegister/CurebayReferralDoctors";
import CurebayReferralBooking from "../components/PatientRegister/CurebayReferralBooking";
import CurebayOrderStatus from "../components/Payment/curebayOrderStatus";

const DashboardRouter = () => {
  const tenantId = localStorage.getItem("tenantId") || "";
  const isCureBay = tenantId?.trim() === "CureBay";
  return isCureBay ? <CurebayBackofficeDashboard /> : <Dashboard />;
};

const checkIsLoggedIn = () => {
  try {
    return localStorage.getItem("auth_token");
  } catch (error) {
    console.error("Error checking login status:", error);
    return null;
  }
};

const PrivateRoute = ({ children }) => {
  const isLoggedIn = checkIsLoggedIn();
  if (!isLoggedIn) {
    localStorage.clear();
    return <Navigate to={APP_ROUTES.LOGIN} />;
  }
  return children;
};

const OurRoutes = () => {
  return (
    <Routes>
      {/* Default Route */}
      <Route path="/" element={<Navigate to={APP_ROUTES.LOGIN} />} />

      {/* Public Routes */}
      <Route path={APP_ROUTES.LOGIN} element={<Login />} />
      <Route path={APP_ROUTES.SIGNUP} element={<Signup />} />
      <Route path={APP_ROUTES.SHARECALL} element={<Sharecall />} />
      <Route path={APP_ROUTES.ORDER_TRACKING} element={<OrderTracking />} />
      <Route path={APP_ROUTES.DOCTOR_DETAILS} element={<DoctorDetails />} />
      <Route path={APP_ROUTES.PATIENT_FEEDBACK} element={<PatientFeedback />} />
      <Route
        path={APP_ROUTES.DASHBOARD}
        element={
          <PrivateRoute>
            <DashboardRouter />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENTREGISTER}
        element={
          <PrivateRoute>
            <Patientregister />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.VITAL}
        element={
          <PrivateRoute>
            <VitalDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.MEDICALHISTORY}
        element={
          <PrivateRoute>
            <Medicalhistory />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.SLOTBOOKING}
        element={
          <PrivateRoute>
            <SlotBooking />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.QUEUEMANAGEMENT}
        element={
          <PrivateRoute>
            <QueueManagement />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENTPREVIEW}
        element={
          <PrivateRoute>
            <PatientPreview />
          </PrivateRoute>
        }
      />

      <Route
        path={APP_ROUTES.DOCTORONBOARDING}
        element={
          <PrivateRoute>
            <DoctorOnboarding />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.DOCTOR_EDIT}
        element={
          <PrivateRoute>
            <DoctorEdit />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.BOOKSERVICE}
        element={
          <PrivateRoute>
            <BookService />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PAYMENTPAGE}
        element={
          <PrivateRoute>
            <Paymentpage />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.ORDERSTATUS}
        element={
          <PrivateRoute>
            <OrderStatus />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.REPORTS}
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PAYMENTDETAILS}
        element={
          <PrivateRoute>
            <Payment />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICSTAFFOB}
        element={
          <PrivateRoute>
            <ClinicStaffOnboard />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINIC_STAFF_EDIT}
        element={
          <PrivateRoute>
            <ClinicStaffEdit />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENTDETAILS}
        element={
          <PrivateRoute>
            <PatientDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.FULLSCREENLOADER}
        element={
          <PrivateRoute>
            <FullScreenLoader />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.VIEWVITAL}
        element={
          <PrivateRoute>
            <Viewvital />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.LABCART}
        element={
          <PrivateRoute>
            <Labcart />
          </PrivateRoute>
        }
      />
      <Route path={APP_ROUTES.SMART_VITAL_FORM} element={<FormComponent />} />
      <Route path={APP_ROUTES.VIDEO_CAPTURE} element={<VideoCapture />} />
      <Route path={APP_ROUTES.CARTDROPDOWN} element={<CartDropdown />} />
      <Route path={APP_ROUTES.MYPROFILE} element={<MyProfile />} />
      <Route path={APP_ROUTES.ADMIN_PROFILE} element={<AdminProfile />} />
      <Route path={APP_ROUTES.CHANGE_PASSWORD} element={<ChangePassword />} />
      <Route path={APP_ROUTES.FEEDBACK} element={<FeedbackPage />} />

      <Route
        path={APP_ROUTES.ADMIN_ONBOARDING}
        element={
          <PrivateRoute>
            <AdminOnboarding />
          </PrivateRoute>
        }
      />

      <Route
        path={APP_ROUTES.ADMIN_LIST}
        element={
          <PrivateRoute>
            <AdminList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DOCTOR_ONBOARDING}
        element={
          <PrivateRoute>
            <CurebayDoctorOnboarding />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DOCTOR_VERIFY}
        element={
          <PrivateRoute>
            <CurebayDoctorVerify />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DOCTOR_EDIT}
        element={
          <PrivateRoute>
            <CurebayDoctorEdit />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DOCTOR_LIST}
        element={
          <PrivateRoute>
            <CurebayDoctorList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_PATIENT_FEEDBACK}
        element={
          <PrivateRoute>
            <CurebayPatientFeedback />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_PAYMENT_INVOICE}
        element={
          <PrivateRoute>
            <CurebayPaymentInvoice />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_SLOT_MANAGEMENT}
        element={
          <PrivateRoute>
            <CurebaySlotManagement />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_LEAVE}
        element={
          <PrivateRoute>
            <CurebayLeave />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DIAGNOSIS_MASTER}
        element={
          <PrivateRoute>
            <CurebayDiagnosisMaster />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_DOCTOR_PAYMENTS}
        element={
          <PrivateRoute>
            <CurebayDoctorPayments />
          </PrivateRoute>
        }
      />

      <Route
        path={APP_ROUTES.MEDICINECARTPAGE}
        element={<MedicineCartPage />}
      />
      <Route path={APP_ROUTES.LABCARTPAGE} element={<LabCartPage />} />
      <Route
        path={APP_ROUTES.CARESATHI}
        element={
          <PrivateRoute>
            <Newcaresathi />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.DELIVERY_MODAL}
        element={
          <PrivateRoute>
            <DeliveryModal />
          </PrivateRoute>
        }
      />
      {/* <Route
        path={APP_ROUTES.SHARECALL}
        element={
          <PrivateRoute>
            <Sharecall />
          </PrivateRoute>
        }
      /> */}

      <Route
        path={APP_ROUTES.PATIENTDETAILSDATA}
        element={
          <PrivateRoute>
            <PatientDetailsdata />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENTVIEW}
        element={
          <PrivateRoute>
            <PatientView />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICDIAGNOSTICDETAILS}
        element={
          <PrivateRoute>
            <ClinicDiagnosticDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICMEDICINEDETAILS}
        element={
          <PrivateRoute>
            <ClinicMedicineDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICRADIOLOGYDETAILS}
        element={
          <PrivateRoute>
            <ClinicRadiologyDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICSURGERYDETAILS}
        element={
          <PrivateRoute>
            <ClinicSurgeryDetails />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINICAMBULANCEDETAILS}
        element={
          <PrivateRoute>
            <ClinicAmbulanceDetails />
          </PrivateRoute>
        }
      />

      <Route
        path={APP_ROUTES.BOOKSERVICESCARD}
        element={
          <PrivateRoute>
            <BookServicescard />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.DOCTORLIST}
        element={
          <PrivateRoute>
            <DoctorList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.RECEPTIONISTLIST}
        element={
          <PrivateRoute>
            <ReceptionistList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENTLIST}
        element={
          <PrivateRoute>
            <PatientList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.PATIENT_PENDING_LIST}
        element={
          <PrivateRoute>
            <PatientPendingList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CONSULTATION_LIST}
        element={
          <PrivateRoute>
            <ConsultationList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CAMP_DETAILS}
        element={
          <PrivateRoute>
            <CampPatient />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.HOSPITAL_CAMP_DETAILS}
        element={
          <PrivateRoute>
            <CampDetailsList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CAMP_PATIENT_DETAIL}
        element={
          <PrivateRoute>
            <CampPatientDetailPage />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.KAVACH_ENROLLMENT}
        element={
          <PrivateRoute>
            <KavachEnrollment />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.EDIT_PRESCRIPTION}
        element={
          <PrivateRoute>
            <EditPrescriptionPage />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.VIEW_PRESCRIPTION}
        element={
          <PrivateRoute>
            <ViewPrescription />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.ADD_ADDRESS}
        element={
          <PrivateRoute>
            <AddAddress />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CLINIC_ONBOARDING}
        element={
          <PrivateRoute>
            <ClinicOnboarding />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.HOSPITAL_LIST}
        element={
          <PrivateRoute>
            <HospitalList />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_REFERRAL_DOCTORS}
        element={
          <PrivateRoute>
            <CurebayReferralDoctors />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_REFERRAL_BOOKING}
        element={
          <PrivateRoute>
            <CurebayReferralBooking />
          </PrivateRoute>
        }
      />
      <Route
        path={APP_ROUTES.CUREBAY_ORDER_STATUS}
        element={<CurebayOrderStatus />}
      />

    </Routes>
  );
};

export { OurRoutes };
